export default __webpack_public_path__ + "static/filehammock-f24e869e7bb3165cbe502a339f1ec035.png";